var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-card-foot-item',[(_vm.value || !_vm.invalid)?_c('core-progress',{staticClass:"card-foot-progress-percent",attrs:{"percent":_vm.value}}):_vm._e(),(!_vm.value && _vm.invalid)?_c('div',{staticClass:"card-foot-progress-value is-invalid"},[_vm._v("n/a")]):_vm._e(),_c('core-card-foot-item-label',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }